import React, { Component } from 'react'
import {BrowserRouter as Router,Link, Redirect, Route } from 'react-router-dom';
import '../css/Admin_css/admin-customize.css';
import COLORS from '../resources/colors/COLORS';
import icon_student_id_card from '../resources/icons/icons_student_id_card_100_white.png'
import StudentIdCard from './StudentIdCard';
export default class PrintMaster extends Component {


  componentDidMount()
  {
      window.scrollTo(0, 0);
      
  }

  render() {
 
    return (
      
      <Router>
        <switch>
          <Route path={'/AdminMain/PrintMaster/:module_id'}  exact render={
            ()=>{
          return(

               <div className="content">
          <div className="content-header">
            <div className="leftside-content-header">
              <ul className="breadcrumbs">
                <li><i className="fa fa-home" aria-hidden="true" /><a href="#"> Print Master </a></li>
              </ul>
            </div>
          </div>
              <div className="row animated fadeInUp bg_page_grey_rounded box_shadow" style={{'--mMargin':'50px',marginTop:'20px'}}>
               
                  <div className="col-sm-4 col-md-4" style={{padding:'10px'}}>
                  <Link to="/AdminMain/StudentIdCard">
                  <div className="row class-list-box">
                  <div className="col-sm-4" style={{background: COLORS.primary_color_shade6,padding:'1em'}}>
                    <div>
                          <img src={icon_student_id_card} className="admission-dashboard-img" alt="student list image"/>
                      </div>
                  </div>
                  <div className="col-sm-8 gravity_center">
                  <h4 className="text-center"> Student Id Card </h4>
                  </div>
                  </div>
                  </Link>
                  </div>

                  
                </div>
               </div>
  
            )
           }
         } />
    <Route path='/AdminMain/StudentIdCard'  component={StudentIdCard} />
           
</switch>

</Router>
  )
} 
}
